import { FormControl, InputLabel, makeStyles, MenuItem, Select } from "@material-ui/core";
import { ChangeEvent, FC, memo, useState } from "react";

import { GenericFunction } from "../types/generic.types";
import { areEqual } from "../utils/generic";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minWidth: "200px",
    margin: "8px 0",
    "& label": {
      zIndex: 1,
      padding: theme.spacing(0, 0.5),
      transform: "translate(10px, 12px) scale(1)",
      pointerEvents: "none",
    },
  },
  filledInput: {
    transform: "translate(8px, -5.5px) scale(0.75) !important",
  },
  errorMSG: {
    color: "#e57373",
    margin: "0 16px",
    fontSize: ".85rem",
    lineHeight: "1.66",
    fontWeight: 400,
    visibility: "hidden",
  },
  showError: {
    visibility: "visible",
  },
}));

const CustomSelect: FC<CustomSelectProps> = ({
  handleSelectItem,
  selectedItem,
  labelTitle,
  multiple = false,
  showErrorMSG = true,
  listItems,
  cashedListItems = [],
  labelBG = "#fafafa",
  disabled = false,
}) => {
  const classes = useStyles({});
  const [checkError, setCheckError] = useState<boolean>(false);

  const handleSelect = (e: ChangeEvent<{ name?: string; value: unknown }>) => {
    handleSelectItem(e.target.value as any, e);
  };

  const checkFocusInput = () => {
    setCheckError(true);
  };

  return (
    <FormControl className={classes.root} disabled={disabled}>
      <InputLabel
        style={{ backgroundColor: labelBG }}
        error={checkError && !selectedItem.length}
        className={selectedItem.length ? classes.filledInput : ""}
        id={labelTitle}
        required
      >
        {labelTitle}
      </InputLabel>
      <Select
        error={checkError && !selectedItem.length}
        style={{ height: 40 }}
        variant="outlined"
        labelId={labelTitle}
        onChange={handleSelect}
        value={selectedItem}
        fullWidth
        required
        multiple={multiple}
        onBlur={checkFocusInput}
      >
        {listItems.map((entry: any) => (
          <MenuItem key={entry.id} value={entry.id} disabled={cashedListItems.some((id) => id === entry.id)}>
            {entry.name}
          </MenuItem>
        ))}
      </Select>
      {showErrorMSG && (
        <p className={`${classes.errorMSG} ${checkError && !selectedItem.length ? classes.showError : ""}`}>Required</p>
      )}
    </FormControl>
  );
};

interface CustomSelectProps {
  listItems: { id: string | number; name: string }[];
  cashedListItems?: string[];
  selectedItem: any;
  handleSelectItem: GenericFunction;
  labelTitle: string;
  multiple?: boolean;
  showErrorMSG?: boolean;
  labelBG?: string;
  disabled?: boolean;
}

export default memo(CustomSelect, areEqual);
